export default __webpack_public_path__ + "static/media/mg-vid-3.cb0d33cb.mp4";